/* eslint-disable */
export default {
  header: 'エラー追跡をオフにする',
  content:
    'エラー追跡モードをオフにすると、現在のエラーログがすべて削除されます。続行してもよろしいですか？',
  confirm: 'オフにする',
  cancel: 'キャンセル',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
